import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { isNullOrUndefined } from "../../../../utils/utils";
import {
  setAccountNicknames,
  setAccounts,
  setSelectedAccount,
} from "../../../../redux/reducers/TransactionManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateAccountName } from "../../../../docuclipper/api";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import {
  fetchMfs,
  fetchTls,
  setSelectedChunk,
} from "../../../../redux/reducers/TransactionManager";
import ReassignChunkToAccount from "./ReassignChunkToAccount";
import SelectWithBadge from "./SelectWithBadge";
import {
  getIsBadDateBoolean,
  getIsReconciled,
  getIsReconciledBoolean,
} from "./SummaryTableAccountViewHorizontal";

type Props = {
  showAccountsHeading?: boolean;
  showEditAccountName?: boolean;
  renderReconciled?: any;
};
export const PeriodSelector: React.FC<Props> = ({
  showAccountsHeading,
  showEditAccountName,
  renderReconciled,
}) => {
  const dispatch = useDispatch();
  const { totalsByDocumentId, totalsByChunk } = useSelector(
    (state: ReduxState) => state.Reconciler
  );
  const { selectedAccount } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );

  const {
    mfs,
    selectedDocumentId,
    selectedFieldNames,
    selectedTransactionStatus,
    selectedChunk,
    accountChunkLabels,
    accountChunks,
  } = useSelector((state: ReduxState) => state.TransactionManager);
  const { mfs: fields, loading: mfsLoading, error: mfsError } = mfs;

  React.useEffect(() => {
    if (accountChunks.length > 0) {
      dispatch(setSelectedChunk(accountChunks[0]));
    }
  }, [accountChunks.length, selectedAccount]);

  const [showEditAccount, setShowEditAccount] = React.useState(false);
  const [newAccountName, setNewAccountName] = React.useState(selectedAccount);
  const toggleShowEditAccount = () => setShowEditAccount(!showEditAccount);
  const options = accountChunks.map((chunk, i) => ({
    label: accountChunkLabels[chunk],
    value: chunk,
    reconciled: getIsReconciledBoolean(fields, selectedAccount || "", chunk),
    reconciledType: "period",
    isBadDate: getIsBadDateBoolean(fields, selectedAccount || "", chunk),
  }));
  let selectedOption: any = null;
  const matches = options.filter((x) => x.value === selectedChunk);
  if (matches.length > 0) {
    selectedOption = matches[0];
  }
  return (
    <>
      {accountChunks.length > 0 && (
        <>
          <Row className="align-items-center">
            {showAccountsHeading && (
              <strong>
                <Form.Label className="mx-1">Period</Form.Label>
              </strong>
            )}
            <div style={{ width: "80%" }}>
              <SelectWithBadge
                value={selectedOption}
                onChange={(e) => {
                  dispatch(setSelectedChunk(e.value));
                }}
                options={options}
              />
            </div>
          </Row>
        </>
      )}
    </>
  );
};
export default PeriodSelector;

PeriodSelector.defaultProps = {
  showAccountsHeading: true,
  showEditAccountName: true,
  renderReconciled: () => null,
};
